import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { GenerateSubcontasListaColumns } from "./columns"
import { StyledDataGridTree } from "../../../../../common/components/styled_data_grid_tree"
import { useSubcontasListaViewModel } from "../../viewModels/subconta_lista_view_model"
import { SubcontaLista } from "../../../domain/models/subconta_lista"
import { SubcontaCadastroModal } from "./components/subconta_cadastro_modal"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"


export const SubcontasLista = () => {
    const viewModel = useSubcontasListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateSubcontasListaColumns({
            onActionEdit: viewModel.handleEditSubcontasOpenState,
            onActionDelete: viewModel.handleSubcontasDeleteOpenState,
        });
    }, [
        viewModel.handleEditSubcontasOpenState,
        viewModel.handleSubcontasDeleteOpenState,
    ]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">
                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleEditSubcontasOpenState(null, true)}>
                                    Nova subconta
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        subcontas
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Subcontas</h1>
                        <p>Pesquisar </p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>
                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                codigo={viewModel.filters.codigo}
                                descricao={viewModel.filters.descricao}
                                status={viewModel.filters.status}
                                handleCodigoChange={viewModel.handleCodigoChange}
                                handleDescricaoChange={viewModel.handleDescricaoChange}
                                handleStatusChange={viewModel.handleStatusChange}
                                onClearFilters={viewModel.handleClearFilters}
                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGridTree
                                    tableName="Subcontas_Lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: SubcontaLista) => row.idSubconta}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.subcontasLista}
                                    rowCount={viewModel.subcontasLista.length}

                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idSubconta'],
                                    }}
                                    //tree data
                                    treeData
                                    getTreeDataPath={(row) => row.path}
                                    getRowClassName={(params) => {
                                        // Verifica se é linha pai (nível 1 da hierarquia)
                                        return params.row.path?.length === 1 ? 'parent-row' : '';
                                    }}
                                    groupingColDef={{
                                        headerName: "Código",
                                        hideDescendantCount: true,
                                        flex: 1,
                                        valueFormatter: (value: string) => value.split("-")[0],
                                    }}
                                    sx={{
                                        '& .parent-row': {
                                            backgroundColor: '#f5f5f5',
                                            '&:hover': {
                                                backgroundColor: '#eeeeee',
                                            },
                                        },
                                        '& .parent-row.Mui-selected': {
                                            backgroundColor: '#e0e0e0',
                                            '&:hover': {
                                                backgroundColor: '#d5d5d5',
                                            },
                                        },
                                        '& .MuiDataGrid-treeDataGroupingCell': {
                                            paddingLeft: '48px !important',
                                        },
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>


                        </>
                    )
                }

            </div >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                onClose={() => viewModel.handleSubcontasDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarSubcontas}
            />

            <SubcontaCadastroModal
                open={viewModel.openCadastroModal}
                onClose={() => viewModel.handleEditSubcontasOpenState(null, false)}
                onSubmit={viewModel.handleSalvarSubcontas}
                saving={viewModel.saving}
                onOpenChangeHistory={viewModel.handleOpenChangeHistory}
                selectedSubconta={viewModel.selectedSubconta}
            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />        </>
    )
}
